import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface WellTest {
  date: string;
  oil: number;
  gas: number;
  wc: number;
  gor: number;
  thp: number;
  gasInjRate: number;
  choke: number;
  liquid: number;
  liquidModel: number;
}

interface NodalAnalysis {
  name: string;
  data: number[];
}

export interface WellInitialState {
  activePage: string;
  wellTests: Array<WellTest>;
  nodalAnalyses: Array<NodalAnalysis>;
}

const initialState: WellInitialState = {
  activePage: "Well History",
  wellTests: [
    {
      date: '01/09/2019',
      oil: 1500,
      gas: 0.21,
      wc: 85,
      gor: 140.0,
      thp: 132.2,
      gasInjRate: 6200,
      choke: 0.00,
      liquid: 10.00,
      liquidModel: 8762.6,
    },
    {
      date: '01/09/2019',
      oil: 1500,
      gas: 0.21,
      wc: 85,
      gor: 140.0,
      thp: 132.2,
      gasInjRate: 6200,
      choke: 0.00,
      liquid: 10.00,
      liquidModel: 8762.6,
    },
    {
      date: '01/09/2019',
      oil: 1500,
      gas: 0.21,
      wc: 85,
      gor: 140.0,
      thp: 132.2,
      gasInjRate: 6200,
      choke: 0.00,
      liquid: 10.00,
      liquidModel: 8762.6,
    }
  ],
  nodalAnalyses: [
    {
      name: "N1",
      data: [16, 361, 1018, 2025, 3192, 4673],
    },
    {
      name: "N2",
      data: [20, 261, 2018, 3025, 4192, 7673],
    }
  ]
}

export const WellSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    changePage: (state, action: PayloadAction<string>) => {
      state.activePage = action.payload;
    },
  }
})

export const { changePage } = WellSlice.actions;
export default WellSlice.reducer;
